import { ContentfulConstraint } from 'services/ContentfulService/utils'
import { Partner } from '../models/partner/partner'

export const ProductConstraint = (productId: string): ContentfulConstraint => {
	return {
		'fields.product.sys.id': productId
	}
}

export const TopicProductConstraint = (productId: string): ContentfulConstraint => {
	return {
		'fields.products.sys.id': productId
	}
}

export const NotHiddenConstraint = (): ContentfulConstraint => {
	return {
		'fields.hidden[ne]': 'true'
	}
}

export const PartnerProductConstraint = (productId: string): ContentfulConstraint => {
	return {
		'fields.availableProducts.sys.id': productId
	}
}

export const PartnerTypeConstraint = (type: Partner['type']): ContentfulConstraint => {
	return {
		'fields.type': type
	}
}

export const TopicConstraint = (topicId: string): ContentfulConstraint => {
	return {
		'fields.topics.sys.id': topicId
	}
}

export const TopicConstraintBySlug = (topicSlug: string): ContentfulConstraint => {
	return {
		'fields.topics.fields.slug[match]': topicSlug
	}
}

export const FeaturedConstraint = (isFeatured = true): ContentfulConstraint => {
	return {
		'fields.featured': `${isFeatured}`
	}
}

export const SlugConstraint = (slug: string): ContentfulConstraint => {
	return {
		'fields.slug': slug
	}
}

export const OrderByNewestConstraint = (): ContentfulConstraint => {
	return {
		order: '-sys.createdAt'
	}
}

export const OrderByDisplayRankContraint = (): ContentfulConstraint => {
	return {
		order: 'fields.displayRank'
	}
}

export const PathConstraint = (path: string) => {
	return { 'fields.path': path }
}

export const IDsConstraint = (ids: string[]) => {
	return {
		'sys.id[in]': ids.join(',') || ''
	}
}
